import { render, staticRenderFns } from "./Conversaciones.vue?vue&type=template&id=5de32859&"
import script from "./Conversaciones.vue?vue&type=script&lang=js&"
export * from "./Conversaciones.vue?vue&type=script&lang=js&"
import style0 from "./Conversaciones.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports